var map = {
	"./no_data_black.png": "ab14",
	"./no_data_blue.png": "2855",
	"./no_data_earthquake.png": "a1dd",
	"./no_data_flood.png": "e052",
	"./no_data_green.png": "0f05",
	"./no_data_grey.png": "dc70",
	"./no_data_purple.png": "fec0",
	"./no_data_red.png": "c695",
	"./no_data_seerist.png": "a5e1",
	"./no_data_volcano.png": "123b",
	"./noimage.png": "17dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "debf";